var map = {
	"./alarm.png": "65cc",
	"./default.png": "2714",
	"./inbox.png": "a9a1",
	"./install.png": "2336",
	"./online.png": "4dd4",
	"./register.png": "d4db",
	"./repaire.png": "e8b4",
	"./type.png": "91f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c81";